import React from "react";
import { FaRegFaceFrown } from "react-icons/fa6";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div className="h-screen  flex flex-col gap-10 justify-center items-center">
      <FaRegFaceFrown className="text-gray-500 text-9xl " />
      <h2 className="text-6xl tracking-widest text-red-500 ">404</h2>
      <h2 className="text-4xl  text-gray-400 ">Page Not Found</h2>
      <Link
        to="/"
        className="text-blue-500 text-xl underline hover:no-underline"
      >
        {" "}
        Back To Home{" "}
      </Link>
    </div>
  );
};

export default ErrorPage;
